<pw-progress-bar *ngIf="totalQuantity >0"></pw-progress-bar>
<div *ngIf="totalQuantity === 0" class="empty-cart-content">
    <h3>{{"shoppingCart.cartIsEmpty" | translate}}</h3>
    <button routerLink="/book">{{"shoppingCart.continueToBuy" | translate}}</button>
</div>
<div *ngIf="totalQuantity > 0" class="cartsummary-container">
    <div *ngIf="totalQuantity >0" class="cart-title">
        <h3>{{"shoppingCart.orderSummary" | translate}}</h3>
    </div>
    <div class="datas">
        <div class="personal-datas">
            <div class="personal-datas-content">
                <h4>{{"shoppingCart.personalDatas" | translate}}</h4>
                <span>{{personalData?.companyName}}</span>
                <span>{{personalData?.lastName}} {{personalData?.firstName}}</span>
                <span>{{personalData?.email}}</span>
                <span>{{personalData?.zipCode}}</span>
                <span>{{personalData?.settlement}}</span>
                <span>{{personalData?.address}}</span>
                <span *ngIf="personalData?.isCompany">{{"shoppingCart.VAT" | translate}} :
                    {{personalData?.taxNumber}}</span>
            </div>
        </div>
        <div class="delivery-details">
            <div class="delivery-details-content">
                <h4>{{"shoppingCart.delivery" | translate}}</h4>
                <div *ngIf="deliveryData?.deliveryOption!='STORE_PICKUP'" class="delivery-infos">
                    <span *ngIf="deliveryData?.deliveryOption =='PACKETA'">{{deliveryData?.deliveryZipCode}}
                        {{deliveryData?.deliverySettlement}}</span><br />
                    <span>{{deliveryData?.deliveryAddress}}</span><br />
                    <span>{{deliveryData?.deliveryOption}}</span>
                </div>
                <div *ngIf="deliveryData?.deliveryOption==='STORE_PICKUP'" class="individual-delivery">
                    <span>{{"shoppingCart.deliveryInterval" | translate}}</span><br />
                    <span>{{"shoppingCart.address" | translate}}</span><br />
                    <span>{{"shoppingCart.phoneNumber" | translate}}</span><br />
                    <span>{{"shoppingCart.emailAddress" | translate}}</span><br />
                </div>
            </div>
        </div>
        <div class="type-of-payment">
            <div class="type-of-payment-content">
                <h4>{{"shoppingCart.payment" | translate}}</h4>
                <span *ngIf="paymentOptions === 'SIMPLE'">{{"shoppingCart.simple" | translate}}</span>
                <span
                    *ngIf="paymentOptions ==='CASH' && deliveryData?.deliveryOption==='STORE_PICKUP'">{{"shoppingCart.storePickup"
                    | translate}}</span>
                <span
                    *ngIf="paymentOptions ==='CASH' && deliveryData?.deliveryOption==='FOXPOST'">{{"shoppingCart.payWithFoxpost"
                    | translate}}</span>
                <span
                    *ngIf="paymentOptions ==='CASH' && deliveryData?.deliveryOption==='PACKETA'">{{"shoppingCart.payWithPacketa"
                    | translate}}</span>
            </div>
        </div>
    </div>
    <!--this table shows, if order is not separated-->

    <div *ngIf="totalQuantity > 0" class="cartsum-container">
        <div *ngIf="!separated || deliveryData?.deliveryOption==='STORE_PICKUP'">
            <div [ngStyle]="material.packageName ? { background: '#ededed' } : { background: 'none' }"
                *ngFor="let material of materials; let i = index" class="cart-table">
                <table>
                    <tr *ngIf="i===0">
                        <th>{{"shoppingCart.cover" | translate}}</th>
                        <th>{{"shoppingCart.author" | translate}}</th>
                        <th>{{"shoppingCart.title" | translate}}</th>
                        <th>{{"shoppingCart.quantity" | translate}}</th>
                        <th>{{"shoppingCart.sum" | translate}}</th>
                    </tr>
                    <tr>
                        <td><img src="{{material.url}}" /></td>
                        <td>{{material.author}}</td>
                        <td>
                            <div *ngIf="material.packageName" class="if-package">
                                <b> {{material.packageName}} csomag</b>
                            </div>
                            <div *ngIf="material.hasPreorder" class="if-package">
                                <b>Előrendelés</b>
                            </div>
                            <div>{{material.title}}</div>
                        </td>
                        <td>{{material.quantity}} db</td>
                        <td><label *ngIf="material.discountLimitedUntil != null">Árkötött kiadvány
                            </label>{{material.originalPrice!*material.quantity! | currency : 'Ft' : 'symbol' :
                            '1.0-0'}}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div *ngIf="separated && deliveryData?.deliveryOption!=='STORE_PICKUP'" class="separated">
            <div class="iterate-class" *ngFor="let product of productList; let i = index">
                <div class="delivery-info">
                    <p>{{product.expectedDeliveryDate}}</p>
                    <p>
                        Szállítási költség: {{product.deliveryFee | currency : 'Ft' : 'symbol' : '1.0-0'}}
                    </p>
                    <p>Tétel összege: {{product.sum | currency : 'Ft' : 'symbol' : '1.0-0'}}</p>
                </div>
                <div *ngFor="let preorderproduct of product.materialList; let i = index" class="cart-table">
                    <table>
                        <tr *ngIf="i===0">
                            <th>{{"shoppingCart.cover" | translate}}</th>
                            <th>{{"shoppingCart.author" | translate}}</th>
                            <th>{{"shoppingCart.title" | translate}}</th>
                            <th>{{"shoppingCart.quantity" | translate}}</th>
                            <th>{{"shoppingCart.sum" | translate}}</th>
                        </tr>
                        <tr>
                            <td><img src="{{preorderproduct.url}}" /></td>
                            <td>{{preorderproduct.author}}</td>
                            <td>
                                <div *ngIf="preorderproduct.packageName" class="if-package">
                                    <b> {{preorderproduct.packageName}} csomag</b>
                                </div>
                                <div *ngIf="preorderproduct.hasPreorder" class="if-package">
                                    <b>Előrendelés</b>
                                </div>
                                <div>{{preorderproduct.title}}</div>
                            </td>
                            <td>{{preorderproduct.quantity}} db</td>
                            <td>{{preorderproduct.originalPrice!*preorderproduct.quantity! | currency : 'Ft' : 'symbol'
                                : '1.0-0'}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="cart-and-sum">
            <div class="sum">
                <div class="cart-quantity">
                    <h4>{{"shoppingCart.totalAmountOfbooks" | translate}}:</h4>
                    <h4>{{ totalPrice | currency : 'Ft' : 'symbol' : '1.0-0' }}</h4>
                </div>
                <div class="delivery-type">
                    <h4>{{"shoppingCart."+typeOfDelivery | translate}}</h4>
                    <!-- <h4 *ngIf="deliveryData?.deliveryFee!==0">{{deliveryFee| currency : 'Ft' : 'symbol' : '1.0-0'}}</h4>
                    <h4 *ngIf="deliveryData?.deliveryFee===0">{{"shoppingCart.freeOfCharge" | translate}}</h4> -->
                    <h4 *ngIf="deliveryFeeSum!==0">{{deliveryFeeSum | currency : 'Ft' : 'symbol' : '1.0-0'}}</h4>
                    <h4 *ngIf="deliveryFeeSum===0">{{"shoppingCart.freeOfCharge" | translate}}</h4>
                </div>
                <div *ngIf="deliveryData?.handlingFee!==0" class="handling-fee">
                    <h4>Kezelési és csomagolási díj</h4>
                    <h4>{{deliveryData?.handlingFee| currency : 'Ft' : 'symbol' : '1.0-0'}}</h4>
                </div>
                <div class="cart-total">
                    <h4>{{"shoppingCart.total" | translate}}:</h4>
                    <!-- <h4>{{ totalPrice + deliveryFee!+deliveryData?.handlingFee! | currency : 'Ft' : 'symbol' : '1.0-0' }}</h4> -->
                    <h4>{{ totalPrice + deliveryFeeSum!+deliveryData?.handlingFee! | currency : 'Ft' : 'symbol' :
                        '1.0-0' }}</h4>
                </div>
            </div>
        </div>
        <div class="newsletter-aszf">
            <div class="news">
                <input (click)="getNewsLetterOrNot()" type="checkbox" />
                <p>{{"shoppingCart.newsLetter" | translate}}</p>
            </div>
            <div class="aszf">
                <input (click)="applyAszfOnClick()" type="checkbox" />
                <p>
                    {{"shoppingCart.aszfContentFirst" | translate}}
                    <a href="./assets/documents/multiverzum_aszf.pdf"
                        target="_blank"><span>{{"shoppingCart.aszfContentSecond" | translate}}</span></a>
                    {{"shoppingCart.aszfContentThird" | translate}}
                    <span><a href="./assets/documents/adatkezelesi_tajekoztato.pdf"
                            target="_blank">{{"shoppingCart.privacyPolicy" | translate}}</a></span>
                    {{"shoppingCart.aszfContentFifth" | translate}}
                </p>
            </div>
        </div>
        <div *ngIf="isAszfCheckBoxRed" class="error">{{errorMessage}}</div>
        <div class="back-and-to-buttons">
            <div class="buttons">
                <button routerLink="/payment">{{"shoppingCart.backToPayment" | translate}}</button>
                <button (click)="goToOrderInformations()">{{"shoppingCart.confirmOrder" | translate}}</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="totalQuantity > 0" class="confirmation-box-mobile">
    <div *ngIf="totalQuantity >0" class="cart-title">
        <h3>{{"shoppingCart.orderSummary" | translate}}</h3>
    </div>
    <div class="datas">
        <div class="personal-datas">
            <div class="personal-datas-content">
                <h4>{{"shoppingCart.personalDatas" | translate}}</h4>
                <span>{{personalData?.companyName}}</span>
                <span>{{personalData?.lastName}} {{personalData?.firstName}}</span>
                <span>{{personalData?.email}}</span>
                <span>{{personalData?.zipCode}}</span>
                <span>{{personalData?.settlement}}</span>
                <span>{{personalData?.address}}</span>
                <span *ngIf="personalData?.isCompany">{{personalData?.taxNumber}}</span>
            </div>
        </div>
        <div class="delivery-details">
            <div class="delivery-details-content">
                <h4>{{"shoppingCart.delivery" | translate}}</h4>
                <div *ngIf="deliveryData?.deliveryOption!='STORE_PICKUP'" class="delivery-infos">
                    <span *ngIf="deliveryData?.deliveryOption=='PACKETA'">{{deliveryData?.deliveryZipCode}}
                        {{deliveryData?.deliverySettlement}}</span><br />
                    <span>{{deliveryData?.deliveryAddress}}</span><br />
                    <span>{{deliveryData?.deliveryOption}}</span><br />
                </div>
                <div *ngIf="deliveryData?.deliveryOption==='STORE_PICKUP'" class="individual-delivery">
                    <span>{{"shoppingCart.deliveryInterval" | translate}}</span><br />
                    <span>{{"shoppingCart.address" | translate}}</span><br />
                    <span>{{"shoppingCart.phoneNumber" | translate}}</span><br />
                    <span>{{"shoppingCart.emailAddress" | translate}}</span><br />
                </div>
            </div>
        </div>
        <div class="type-of-payment">
            <div class="type-of-payment-content">
                <h4>{{"shoppingCart.payment" | translate}}</h4>
                <span *ngIf="paymentOptions === 'SIMPLE'">{{"shoppingCart.simple" | translate}}</span>
                <span
                    *ngIf="paymentOptions ==='CASH' && deliveryData?.deliveryOption==='FOXPOST'">{{"shoppingCart.payWithFoxpost"
                    | translate}}</span>
                <span *ngIf="paymentOptions === 'CASH'">{{"shoppingCart.storePickup" | translate}}</span>
            </div>
        </div>
    </div>
</div>
<div *ngIf="totalQuantity > 0" class="cartsum-container-mobile">
    <div *ngIf="!separated || deliveryData?.deliveryOption==='STORE_PICKUP'">
        <div *ngFor="let material of materials; let i = index" class="table-cart">
            <table [ngStyle]="{backgroundColor: i%2 === 0 ? 'white' : '#e8fcfd'}">
                <tr>
                    <td>
                        <img src="{{material.url}}" />
                        <div class="title-author">
                            <div class="book-data">
                                <b *ngIf="material.packageName">{{material.packageName}} csomag</b><br />
                                <b [ngStyle]="{'font-style':'italic'}"
                                    *ngIf="material.hasPreorder">Előrendelés</b><br />
                                <label>{{material.author}}</label><br />
                                <label>{{material.title}}</label><br />
                            </div>
                        </div>
                        <label>{{material.quantity}} {{"shoppingCart.piece" | translate}}</label>
                        <label><label *ngIf="material.discountLimitedUntil != null">Árkötött kiadvány
                            </label>{{material.originalPrice!*material.quantity! | currency : 'Ft' : 'symbol' :
                            '1.0-0'}}</label><br />
                    </td>
                </tr>
            </table>
        </div>
    </div>
    <div *ngIf="separated && deliveryData?.deliveryOption!=='STORE_PICKUP'">
        <div class="iterate-class" *ngFor="let product of productList; let i = index">
            <div class="delivery-info">
                <p>{{product.expectedDeliveryDate}}</p>
                <p>
                    Szállítási költség: {{product.deliveryFee | currency : 'Ft' : 'symbol' : '1.0-0'}}
                </p>
                <p>Tétel összege: {{product.sum | currency : 'Ft' : 'symbol' : '1.0-0'}}</p>
            </div>
            <div *ngFor="let material of product.materialList; let i = index" class="table-cart">
                <table [ngStyle]="{backgroundColor: i%2 === 0 ? 'white' : '#e8fcfd'}">
                    <tr>
                        <td>
                            <img src="{{material.url}}" />
                            <div class="title-author">
                                <div class="book-data">
                                    <b *ngIf="material.packageName">{{material.packageName}} csomag</b><br />
                                    <b [ngStyle]="{'font-style':'italic'}"
                                        *ngIf="material.hasPreorder">Előrendelés</b><br />
                                    <label>{{material.author}}</label><br />
                                    <label>{{material.title}}</label><br />
                                </div>
                            </div>
                            <label>{{material.quantity}} {{"shoppingCart.piece" | translate}}</label>
                            <label><label *ngIf="material.discountLimitedUntil != null">Árkötött kiadvány
                                </label>{{material.originalPrice!*material.quantity! | currency : 'Ft' : 'symbol' :
                                '1.0-0'}}</label><br />
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

    <div class="cart-and-sum">
        <div class="sum">
            <div class="cart-quantity">
                <h4>{{"shoppingCart.totalAmountOfbooks" | translate}}:</h4>
                <h4>{{ totalPrice | currency : 'Ft' : 'symbol' : '1.0-0' }}</h4>
            </div>
            <div class="delivery-type">
                <h4>{{"shoppingCart."+typeOfDelivery | translate}}</h4>
                <!-- <h4 *ngIf="deliveryData?.deliveryFee!==0">{{deliveryFee | currency : 'Ft' : 'symbol' : '1.0-0'}}</h4>
                <h4 *ngIf="deliveryData?.deliveryFee===0">{{"shoppingCart.freeOfCharge" | translate}}</h4> -->
                <h4 *ngIf="deliveryFeeSum!==0">{{deliveryFeeSum | currency : 'Ft' : 'symbol' : '1.0-0'}}</h4>
                <h4 *ngIf="deliveryFeeSum===0">{{"shoppingCart.freeOfCharge" | translate}}</h4>
            </div>
            <div *ngIf="deliveryData?.handlingFee!==0" class="handling-fee">
                <h4>Kezelési és csomagolási díj</h4>
                <h4>{{deliveryData?.handlingFee| currency : 'Ft' : 'symbol' : '1.0-0'}}</h4>
            </div>
            <div class="cart-total">
                <h4>{{"shoppingCart.total" | translate}}:</h4>
                <!-- <h4>{{ totalPrice + deliveryFee!+deliveryData?.handlingFee!| currency : 'Ft' : 'symbol' : '1.0-0' }}</h4> -->
                <h4>{{ totalPrice + deliveryFeeSum!+deliveryData?.handlingFee!| currency : 'Ft' : 'symbol' : '1.0-0' }}
                </h4>
            </div>
        </div>
    </div>
    <div class="newsletter-aszf">
        <div class="news">
            <input (click)="getNewsLetterOrNot()" type="checkbox" />
            <p>{{"shoppingCart.newsLetter" | translate}}</p>
        </div>
        <div class="aszf">
            <input (click)="applyAszfOnClick()" type="checkbox" />
            <p>
                {{"shoppingCart.aszfContentFirst" | translate}}
                <a href="./assets/documents/multiverzum_aszf.pdf"
                    target="_blank"><span>{{"shoppingCart.aszfContentSecond" | translate}}</span></a>
                {{"shoppingCart.aszfContentThird" | translate}}
                <span><a href="./assets/documents/adatkezelesi_tajekoztato.pdf">{{"shoppingCart.privacyPolicy" |
                        translate}}</a></span>
                {{"shoppingCart.aszfContentFifth" | translate}}
            </p>
        </div>
    </div>
    <div *ngIf="isAszfCheckBoxRed" class="error">{{errorMessage}}</div>
    <div class="back-and-to-buttons">
        <div class="buttons">
            <button routerLink="/payment">{{"shoppingCart.backToPayment" | translate}}</button>
            <button (click)="goToOrderInformations()">{{"shoppingCart.confirmOrder" | translate}}</button>
        </div>
    </div>
</div>